import React from 'react';

import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Alert = withCoreProps<AlertProps>(
  ({ children, className, ...props }: React.PropsWithChildren<AlertProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAlert {...props} className={clsxClass}>
        {children}
      </MuiAlert>
    );
  },
);

export interface AlertProps extends MuiAlertProps, CoreProps {}
